export default "__VITE_ASSET__329db8f3__"